// extracted by mini-css-extract-plugin
export default {"container":"Layout_container__qFBFW","slide":"Layout_slide__VN8mX"};